import {creates, hoistCmp} from '@xh/hoist/core';
import {WorkflwosTabModel} from './WorkflowsTabModel';
import {filler, hframe, vframe} from '@xh/hoist/cmp/layout';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {toolbar, toolbarSep} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {storeFilterField} from '@xh/hoist/cmp/store';
import {workflowEditor} from './WorkflowEditor';
import {executionLog} from './WorkflowLog';
import {dataCheckDialog} from './DataCheckDialog';

export const workflowsTab = hoistCmp.factory({
    model: creates(WorkflwosTabModel),
    className: 'workflows-tab',
    render({model, className}) {
        return hframe(
            vframe({
                className,
                items: [
                    workflows(),
                    executions(),
                    workflowEditor({model: model.workflowEditor}),
                    dataCheckDialog({model: model.dataCheckDialog})
                ]
            }),
            executionLog({model: model.workflowLog})
        );
    }
});

const workflows = hoistCmp.factory<WorkflwosTabModel>(({model}) =>
    panel({
        tbar: workflowsTbar(),
        item: grid({model: model.workflowsGrid}),
        mask: model.workflowsTask
    })
);

const workflowsTbar = hoistCmp.factory<WorkflwosTabModel>(({model}) =>
    toolbar(
        button({
            text: 'Add',
            icon: Icon.plus(),
            intent: 'success',
            onClick: () => model.addWorkflow()
        }),
        button({
            text: 'Clone',
            icon: Icon.copy(),
            disabled: !model.selectedWorkflow,
            onClick: () => model.cloneWorkflow()
        }),
        button({
            text: 'Edit',
            icon: Icon.edit(),
            intent: 'primary',
            disabled: !model.selectedWorkflow,
            onClick: () => model.editWorkflow()
        }),
        button({
            text: 'Delete',
            icon: Icon.delete(),
            intent: 'danger',
            disabled: !model.selectedWorkflow,
            onClick: () => model.deleteWorkflow()
        }),
        toolbarSep(),
        button({
            text: 'Data Checks',
            icon: Icon.checkCircle(),
            onClick: () => model.openDataChecks()
        }),
        filler(),
        storeFilterField({model: model.workflowsGrid, matchMode: 'any'}),
        button({icon: Icon.refresh(), intent: 'success', onClick: () => model.refreshAllAsync()})
    )
);

const executions = hoistCmp.factory<WorkflwosTabModel>(({model}) =>
    panel({
        modelConfig: {
            defaultSize: '50%',
            collapsible: false,
            resizable: true,
            side: 'bottom'
        },
        item: grid({model: model.executionsGrid}),
        mask: model.workflowsTask
    })
);
